import { type RequestHeaders } from '@shared/request_type'

export function singleValueOrNone(value: RequestHeaders[string]) {
  if (Array.isArray(value)) {
    return value[0]
  }
  return value
}
